function getAtcButton() {
  return document.querySelector('[ref="addToCartButton"]');
}

function syncAtcState() {
  const atcButton = getAtcButton();
  if (!atcButton) return;
  const visible = document.querySelector('.corte-dropdown[style*="display: block"]');

  if (!visible) {
    atcButton.disabled = false;
    return;
  }

  const hidden = visible.querySelector('input[type="hidden"]');
  const needsSelection = hidden && !hidden.value;

  atcButton.disabled = needsSelection;

  const trigger = visible.querySelector('.corte-dropdown__trigger');
  if (needsSelection) {
    if (trigger) trigger.classList.add('corte-dropdown__trigger--error');
    let msg = visible.querySelector('.corte-dropdown__error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'corte-dropdown__error';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Selecciona una opción para continuar';
      visible.appendChild(msg);
    }
  } else {
    if (trigger) trigger.classList.remove('corte-dropdown__trigger--error');
    const err = visible.querySelector('.corte-dropdown__error');
    if (err) err.remove();
  }
}

function shouldShow(dropdown, selectedValue) {
  const raw = dropdown.dataset.conditionalValues;
  if (!raw) return true;
  const allowed = raw.split(',').map((v) => v.trim().toLowerCase());
  return allowed.includes((selectedValue || '').toLowerCase());
}

function updateDropdowns(optionName, selectedValue) {
  document.querySelectorAll('.corte-dropdown').forEach((d) => {
    const dOption = (d.dataset.conditionalOption || '').trim();
    if (dOption === '' || dOption.toLowerCase() !== optionName.toLowerCase()) return;

    const show = shouldShow(d, selectedValue);
    d.style.display = show ? 'block' : 'none';
    const hidden = d.querySelector('input[type="hidden"]');
    if (!show && hidden) {
      hidden.disabled = true;
      hidden.value = '';
      const val = d.querySelector('.corte-dropdown__value');
      if (val) val.textContent = val.dataset.placeholder || '';
    } else if (hidden) {
      hidden.disabled = false;
    }
  });

  syncComponentVisibility();
}

function syncComponentVisibility() {
  const anyVisible = !!document.querySelector('.corte-dropdown[style*="display: block"]');
  const block = document.querySelector('product-custom-property-component');
  if (block) block.style.display = anyVisible ? 'block' : 'none';
  syncAtcState();
}

// Event delegation on document — survives DOM morphing of variant-picker
document.addEventListener('change', (e) => {
  const input = e.target;
  if (!(input instanceof HTMLInputElement) || !input.name || !input.checked) return;

  document.querySelectorAll('.corte-dropdown[data-conditional-option]').forEach((dropdown) => {
    const optionName = dropdown.dataset.conditionalOption.trim();
    if (!input.name.startsWith(optionName + '-')) return;
    updateDropdowns(optionName, input.value);
  });
});

// After variant morph completes, re-sync component visibility based on server-rendered dropdown state
document.addEventListener('variant:update', () => {
  syncComponentVisibility();
});

// Set initial visibility state on page load
function initState() {
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;

  const blockId = variantPicker.getAttribute('data-block-id');
  const productId = variantPicker.getAttribute('data-product-id');

  document.querySelectorAll('.corte-dropdown[data-conditional-option]').forEach((dropdown) => {
    const optionName = dropdown.dataset.conditionalOption.trim();
    const inputName = `${optionName}-${blockId}-${productId}`;
    const checkedInput = document.querySelector(`[name="${inputName}"]:checked`) ||
      document.querySelector(`[name="${inputName}"][data-current-checked="true"]`);
    updateDropdowns(optionName, checkedInput ? checkedInput.value : null);
  });
}

initState();

// Dropdown open/close and option selection
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.corte-dropdown__trigger');

  if (trigger) {
    const wrapper = trigger.closest('.corte-dropdown__select');
    const list = wrapper.querySelector('.corte-dropdown__options');
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    list.toggleAttribute('data-open');
    return;
  }

  const option = e.target.closest('.corte-dropdown__options li');
  if (option) {
    const wrapper = option.closest('.corte-dropdown__select');
    const hidden = wrapper.querySelector('input[type="hidden"]');
    const val = wrapper.querySelector('.corte-dropdown__value');
    const triggerEl = wrapper.querySelector('.corte-dropdown__trigger');
    const list = wrapper.querySelector('.corte-dropdown__options');

    wrapper.querySelectorAll('li[aria-selected]').forEach((li) => li.removeAttribute('aria-selected'));
    option.setAttribute('aria-selected', 'true');
    val.textContent = option.textContent;
    if (hidden) hidden.value = option.dataset.value;
    triggerEl.setAttribute('aria-expanded', 'false');
    list.removeAttribute('data-open');
    syncAtcState();
    return;
  }

  document.querySelectorAll('.corte-dropdown__trigger[aria-expanded="true"]').forEach((t) => {
    t.setAttribute('aria-expanded', 'false');
    t.closest('.corte-dropdown__select').querySelector('.corte-dropdown__options').removeAttribute('data-open');
  });
});
